import { Product } from "../../../contexts/cartContext/cartType";

/**
 * Remove desconto dos produtos, restaurando preço original
 * @param products - Produtos do carrinho (potencialmente com desconto)
 * @returns Produtos sem desconto
 */
export function removeDiscountFromProducts(products: Product[]): Product[] {
  try {
    return products.map((product) => {
      if (product.withDiscout && product.oldDiscountPrice) {
        return {
          ...product,
          promotionalPrice: product.oldDiscountPrice,
          withDiscout: false,
          oldDiscountPrice: undefined,
        };
      }
      return product;
    });
  } catch (error) {
    console.error("Erro ao remover desconto dos produtos:", error);
    return products;
  }
}

/**
 * Remove apenas o desconto de cupom.
 * Preferencialmente o cashback já foi removido antes e será reaplicado depois.
 */
export function removeCouponFromProducts(products: Product[]): Product[] {
  try {
    return products.map((product) => {
      if (
        product.cupomDiscount === undefined &&
        !(product.withDiscout && product.oldDiscountPrice !== undefined)
      ) {
        return product;
      }

      const restoredPrice = product.oldDiscountPrice ?? product.unitPrice;

      return {
        ...product,
        promotionalPrice: restoredPrice,
        cupomDiscount: undefined,
        withDiscout: false,
        oldDiscountPrice: undefined,
      };
    });
  } catch (error) {
    console.error("Erro ao remover cupom dos produtos:", error);
    return products;
  }
}
